export default __webpack_public_path__ + "static/media/5.34959797.jpg";